import { useEffect } from 'react';

import { useAppDispatch } from './app';
import useRawSearchParams from './useRawSearchParams';
import {
  updateShowCliffsDelta,
  updateShowCles,
  updateShowSignificance,
} from '../reducers/ColumnPrefsSlice';
import {
  ADVANCED_COLUMNS_PARAM,
  parseAdvancedColumns,
} from '../utils/advancedColumnsUrl';

// On mount, seed the advanced-column visibility from the URL so a shared link
// reproduces the selected columns. Toggling updates both the URL (for sharing)
// and Redux (for reactive rendering); this only handles the initial
// URL → Redux direction. Call once per results view.
function useSeedAdvancedColumnsFromUrl() {
  const [rawSearchParams] = useRawSearchParams();
  const dispatch = useAppDispatch();
  useEffect(() => {
    const params = new URLSearchParams(rawSearchParams);
    if (!params.has(ADVANCED_COLUMNS_PARAM)) {
      return;
    }
    const { cliffsDelta, cles, significance } = parseAdvancedColumns(params);
    dispatch(updateShowCliffsDelta(cliffsDelta));
    dispatch(updateShowCles(cles));
    dispatch(updateShowSignificance(significance));
  }, []);
}

export default useSeedAdvancedColumnsFromUrl;
